<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';

const store = useStore();

const user = computed(() => store.getters.getUserDetails);

const userRole = computed(() => {
    const attributes = user.value;
    
    if (!Array.isArray(attributes)) {
        return null; 
    }
    
    const roleAttr = attributes.find(attr => attr.Name === 'custom:role');
    
    return roleAttr ? roleAttr.Value : null;
});

</script>
<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper">
    <layouts></layouts>
    <sidebar></sidebar>
    <div class="page-wrapper">
      <div class="content">
        <pageaddheader :title="title" :title1="title1" :items="['admin','issuer'].includes(userRole)?items:null" />

        <!-- /product list -->
        <div class="card">
          <div class="card-body">
            <div class="table-top">
              <div class="search-set">
                <div class="search-path">
                  <a
                    class="btn btn-filter"
                    id="filter_search"
                    v-on:click="filter = !filter; this.search=''"
                    :class="{ setclose: filter }"
                  >
                    <img src="../../../assets/img/icons/filter.svg" alt="img" />
                    <span
                      ><img src="../../../assets/img/icons/closes.svg" alt="img"
                    /></span>
                  </a>
                </div>
                <div class="search-input">
                  <a class="btn btn-searchset"
                    ><img src="../../../assets/img/icons/search-white.svg" alt="img"
                  /></a>
                  <div id="DataTables_Table_0_filter" class="dataTables_filter">
                    <label>
                      <input
                        type="search"
                        v-model="search"
                        class="form-control form-control-sm"
                        placeholder="Search..."
                        aria-controls="DataTables_Table_0"
                        @change="searching"
                      />
                    </label>
                  </div>
                </div>
              </div>
              <!-- <div class="wordset">
                <ul>
                  <li>
                    <a data-bs-toggle="tooltip" data-bs-placement="top" title="pdf"
                      ><img src="../../../assets/img/icons/pdf.svg" alt="img"
                    /></a>
                  </li>
                  <li>
                    <a data-bs-toggle="tooltip" data-bs-placement="top" title="excel"
                      ><img src="../../../assets/img/icons/excel.svg" alt="img"
                    /></a>
                  </li>
                  <li>
                    <a data-bs-toggle="tooltip" data-bs-placement="top" title="print"
                      ><img src="../../../assets/img/icons/printer.svg" alt="img"
                    /></a>
                  </li>
                </ul>
              </div> -->
            </div>
            <!-- /Filter -->
            <!-- <div
              class="card"
              id="filter_inputs"
              :style="{
                display: filter ? 'block' : 'none',
              }"
            >
              <div class="card-body pb-0">
                <div class="row">
                  <div class="col-lg-3 col-sm-6 col-12">
                    <div class="form-group">
                      <input type="text" placeholder="Enter Name" />
                    </div>
                  </div>
                  <div class="col-lg-3 col-sm-6 col-12">
                    <div class="form-group">
                      <input type="text" placeholder="Enter Reference No" />
                    </div>
                  </div>
                  <div class="col-lg-3 col-sm-6 col-12">
                    <div class="form-group">
                      <vue-select :options="Completed" placeholder="Completed" />
                    </div>
                  </div>
                  <div class="col-lg-3 col-sm-6 col-12">
                    <div class="form-group">
                      <a class="btn btn-filters ms-auto"
                        ><img src="../../../assets/img/icons/search-whites.svg" alt="img"
                      /></a>
                    </div>
                  </div>
                </div>
              </div>
            </div> -->
            <!-- /Filter -->
            <div class="table-responsive">
              <a-table
                :columns="columns"
                :data-source="filteredItems"
              >
                <template #bodyCell="{ column, record }">
                  <template v-if="column.key === 'dispatchid'">
                    <div class="productimgname">
                      <a href="javascript:void(0);">{{ record.dispatchitem }}</a>
                    </div>
                  </template>
                  <!-- <template v-else-if="column.key === 'pay'">
                    <span class="badges bg-lightgreen" v-if="record.Payment === 'Paid'">{{
                      record.Payment
                    }}</span>
                    <span class="badges bg-lightred" v-else="record.Payment === 'Due'">{{
                      record.Payment
                    }}</span></template> -->
                  <template v-else-if="column.key === 'action' && userRole=='admin'">
                    <a class="me-3" @click="editdispatch(record)" href="javascript:void(0);">
                      <img src="../../../assets/img/icons/edit.svg" alt="img" />
                    </a>
                    <a
                      class="me-3 confirm-text"
                      href="javascript:void(0);"
                      @click="showAlert(record.dispatchid)"
                    >
                      <img src="../../../assets/img/icons/delete.svg" alt="img" />
                    </a>
                  </template>  
                </template>
              </a-table>
            </div>
          </div>
        </div>
        <!-- /product list -->
      </div>
    </div>
  </div>
  <saleslistmodal></saleslistmodal>
</template>
<script>
import axios from "axios";
import { mapGetters } from 'vuex';
const columns = [
  {
    sorter: true,
  },
  {
    title: "Item Name",
    dataIndex: "dispatchitem",
    key: "dispatchid",
    sorter: {
      compare: (a, b) => {
        a = a.dispatchitem.toLowerCase();
        b = b.dispatchitem.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Quantity",
    dataIndex: "quantity",
    sorter: {
      compare: (a, b) => {
        a = a.quantity;
        b = b.quantity;
        return a > b ? -1 : b > a ? 1 : 0;
      },
    }
  },
  {
    title: "Voucher Code",
    dataIndex: "vouchercode",
    sorter: {
      compare: (a, b) => {
        a = a.vouchercode.toLowerCase();
        b = b.vouchercode.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Department",
    dataIndex: "department",
    sorter: {
      compare: (a, b) => {
        a = a.department.toLowerCase();
        b = b.department.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Issue Date",
    dataIndex: "dispatchdate",
    sorter: {
      compare: (a, b) => {
        a = a.dispatchdate.toLowerCase();
        b = b.dispatchdate.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Action",
    key: "action",
    sorter: true,
  },
];
export default {
  data() {
    return {
      filter: false,
      search: '',
      title: "Issued Items",
      title1: "Manage your Issued Item",
      items: [
        {
          text: "Issue Item ",
          addname: "/add-sales",
        },
      ],
      data: null,
      columns,
      Completed: ["Completed", "Paid"],
    };
  },
  mounted() {
    document.addEventListener('keydown', this.handleKeydown);
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeydown);
  },
  methods: {
    handleKeydown(event) {

      if (this.$route.path === '/saleslist' && event.ctrlKey && (event.key === 'm') || event.ctrlKey && (event.key === 'M')) {
        event.preventDefault(); 
        
        this.$router.push('/add-sales');
      }
    },
    
    searching() {
      if (this.search) this.filter = true;
    },
    showAlert(id) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        showCancelButton: true,
        confirmButtonColor: "#FF9F43",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.isConfirmed) {
          axios
          .delete('/v1/dispatches/'+id)
          .then(response => {
            Swal.fire("Deleted!", "Issue has been deleted.");
            var index = this.data.findIndex(function(o){
              return o.dispatchid === id;
            })
            if (index !== -1) this.data.splice(index, 1);
          })
          .catch(error => {
            console.log(error)
            Swal.fire(error.response.data.detail);
          });
          
        }
      });
    },
    editdispatch(dispatch) {
      this.$router.push({ path: '/edit-sales', query: { id: dispatch.dispatchid } });
    },
    async getDispatch() {
      axios
      .get(`/v1/dispatches?locationid=${this.locationId}`)
      .then(response => {
        this.data = response.data
      })
      .catch(error => {
        console.log(error)
        this.errored = true
      });
    },
  },
  computed: {
    filteredItems() {
      return this.data?this.data.filter(item => {
        return !this.search || 
                item['dispatchitem'].toString().toLowerCase().includes(this.search.toLowerCase());
      }):null;
    },
    ...mapGetters(['getCurrentLocation']),

    currentLocation() { return this.getCurrentLocation; },
    
    locationName() {
      const loc = this.currentLocation;
      return loc ? Object.keys(loc) : null;
    },
    locationId() {
      const loc = this.currentLocation;
      return loc ? loc.id: null;
    },
  },
  beforeMount() {
    this.getDispatch();
  },
  name: "saleslist",
};
</script>
